module.exports = __webpack_public_path__ + "static/media/EROS 500.5c96a8b2.png";